export default __webpack_public_path__ + "static/media/arrow-teal.84b2e285.svg";